import type { ReactNode } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { formatNumber } from './chart-utils';

interface StatCardProps {
  title: string;
  value: number | string;
  icon?: ReactNode;
  description?: string;
}

export const StatCard = ({ title, value, icon, description }: StatCardProps) => (
  <Card className="border-border/70 shadow-none transition-shadow hover:shadow-sm">
    <CardContent className="flex items-start justify-between gap-3 p-5">
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-muted-foreground">{title}</p>
        <p className="mt-2.5 text-2xl font-semibold leading-none tracking-tight tabular-nums text-foreground">
          {typeof value === 'number' ? formatNumber(value) : value}
        </p>
        {description && (
          <p className="mt-2 text-xs text-muted-foreground">{description}</p>
        )}
      </div>

      {icon && (
        <span className="flex size-9 shrink-0 items-center justify-center text-primary">
          {icon}
        </span>
      )}
    </CardContent>
  </Card>
);
